// Module de gestion du menu (touch screen).

import modal from 'Modules/modal'
import cleanTextOnFocus from 'Modules/cleanTextOnFocus'
import _3MPlus from 'Modules/_3MPlus'
import miniPanier from 'Modules/miniPanier'
import { InitialiserWishlistInLocalStorage } from 'Modules/gestionLocalStorage'
import inscriptionModule from 'Modules/inscriptionModule'

function process() {
    const position = $(window).scrollTop()
    $(document).ready(function () {
        import('Modules/ads').then(
            ({ default: { initAdBlockerDetection } }) => {
                initAdBlockerDetection()
            }
        )

        $(function () {
            const $els = $('div[id^=supp]')
            let i = 0
            const len = $els.length
            $els.slice(1).hide()
            setInterval(function () {
                $els.eq(i).fadeOut(function () {
                    i = (i + 1) % len
                    $els.eq(i).fadeIn()
                })
            }, 3500)
        })
    })

    if ($('#modaltest3m10:visible').length > 0) {
        const genre = $(this).data('genre')
        modal.miseAjourParClassCss(
            'modal3M',
            window.location.origin + '/_3MPlus/Modal/?gender=' + genre,
            _3MPlus.process
        )
    } else {
        $(document).on('show.bs.modal', '#modaltest3m10', function () {
            const genre = $(this).data('genre')
            modal.miseAjourParClassCss(
                'modal3M',
                window.location.origin + '/_3MPlus/Modal/?gender=' + genre,
                _3MPlus.process
            )
        })
    }

    if ($('#modal3mlight:visible').length > 0) {
        modal.miseAjourParClassCss(
            'modal3MLight',
            window.location.origin + '/_3MPlus/ModalLight/',
            _3MPlus.processLight
        )
    } else {
        $(document).on('show.bs.modal', '#modal3mlight', function () {
            modal.miseAjourParClassCss(
                'modal3MLight',
                window.location.origin + '/_3MPlus/ModalLight/',
                _3MPlus.processLight
            )
        })
    }

    setDataLinks()

    cleanTextOnFocus.setEvent() // Gestion du texte par défaut à supprimer lors du clique sur un champ texte

    _3MPlus.process() // Mise en place du 3mPlus

    miniPanier.setEvent() // Gestion du rollover du minipanier

    miniPanier.process()

    InitialiserWishlistInLocalStorage()

    inscriptionModule.Process()
}

function setDataLinks() {
    // initialisation de l'offuscation des liens
    $('.lienCache').on('click', function () {
        window.location.href = $(this).data('link')
    })

    $('.linkAjaxReload').unbind('click')
    $('.linkAjaxReload').on('click', function () {
        window.location = $(this).attr('data')
    })
}

export default {
    process: process,
    setDataLinks: setDataLinks
}
